import React from "react";
import style from "../styles/about.module.css";
import { motion } from "framer-motion";
import Reveal from "../components/reveal";
import akilImg from "./Images/akil-profile.jpg";
import {
  TbCircleCheck,
  TbDownload,
  TbTargetArrow,
  TbUsersGroup,
  TbLanguage,
} from "react-icons/tb";
import { profile, stats } from "../data/profile";
import pdf from "./Images/Akil-Sadik-AI-Automation-Engineer-Resume.pdf";

const About = () => (
  <section id="about" className={`about sectionShell ${style.about}`}>
    <div className="sectionInner">
      <Reveal dir="up" amount={0.4}>
        <h2 className="sectionHeading" data-outline="About">
          About
        </h2>
      </Reveal>

      <div className={style.grid}>
        <Reveal dir="left" className={style.photoCol}>
          <motion.div
            className={style.frame}
            whileHover={{ y: -8 }}
            transition={{ type: "spring", stiffness: 260, damping: 22 }}
          >
            <span className={style.frameGlow} />
            <img src={akilImg} alt={profile.name} className={style.photo} />
          </motion.div>
        </Reveal>

        {/* #user-detail-intro lives on the hero role heading — an id must be
            unique, and the scraper reads the first match anyway. */}
        <div className={style.copyCol}>
          <Reveal dir="right" delay={0.05}>
            <p className={style.summary}>{profile.summary}</p>
          </Reveal>

          <Reveal dir="right" delay={0.1}>
            <p className={style.workingStyle}>{profile.workingStyle}</p>
          </Reveal>

          <Reveal dir="up" delay={0.15}>
            <div className={style.strengths}>
              {profile.strengths.map((strength) => (
                <span key={strength} className={style.strength}>
                  <TbCircleCheck /> {strength}
                </span>
              ))}
            </div>
          </Reveal>

          <Reveal dir="up" delay={0.18}>
            <dl className={style.meta}>
              <div className={style.metaRow}>
                <dt>
                  <TbTargetArrow /> Focus
                </dt>
                <dd>{profile.interests.join(" · ")}</dd>
              </div>
              <div className={style.metaRow}>
                <dt>
                  <TbUsersGroup /> Soft skills
                </dt>
                <dd>{profile.softSkills.join(" · ")}</dd>
              </div>
              <div className={style.metaRow}>
                <dt>
                  <TbLanguage /> Languages
                </dt>
                <dd>
                  {profile.languages
                    .map((l) => `${l.name} (${l.level})`)
                    .join(" · ")}
                </dd>
              </div>
            </dl>
          </Reveal>
        </div>
      </div>

      {/* stats sit full width, centred under both columns */}
      <div className={style.statRow}>
        {stats.map((stat, i) => (
          <Reveal dir="up" delay={0.08 * i} key={stat.label} className={style.statWrap}>
            <motion.div className={style.stat} whileHover={{ y: -6 }}>
              <h3 className={`${style.statValue} gradText`}>{stat.value}</h3>
              <p className={style.statLabel}>{stat.label}</p>
            </motion.div>
          </Reveal>
        ))}
      </div>

      <Reveal dir="up" delay={0.1}>
        <a
          className={`resume ${style.resumeBtn}`}
          id="resume-link-2"
          href={pdf}
          download="Akil Sadik - AI Automation Engineer"
        >
          <button id="resume-button-2" className={style.resumeInner}>
            <TbDownload /> Download Resume
          </button>
        </a>
      </Reveal>
    </div>
  </section>
);

export default About;
